'use strict';

// Localisations
// ============
module.exports = {
  en: {
    title: 'Foe Face is currently closed',
    welcometext: 'Due to restriction from schools, FoeFace is only available between 08:30 and 15:30.',
    poweredby: 'Powered By',
    showabout: 'About'
  },
  es: {
    title: 'Foe Face is currently closed',
    welcometext: 'Due to restriction from schools, FoeFace is only available between 08:30 and 15:30.',
    poweredby: 'Powered By',
    showabout: 'About'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/closed/closed.localisations.js